import React, { useEffect } from "react";
import { CHILD_STEPS, ChildProductDetailsFormValues, PRODUCT_PATH } from "./";
import {
  CHILD_ABOUT_STEP,
  CHILD_ABOUT_YOU_STEP,
  CHILD_PRICE_STEP,
} from "./childSteps";

import { Icons } from "@storebrand-digital/insurance-definitions";
import { ActiveStep } from "Components/ActiveStep";
import { useExistingProductState } from "Components/Features/CheckPrice";
import { ProductTile } from "Components/Features/CheckPrice/Tiles/ProductTile";
import { useTexts } from "Components/TextContext";
import { setCheckPriceProducts } from "Store/analytics/analyticsSlice";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import {
  sendPriceCalculationRequestsStart,
  updatePriceCalculationFormState,
} from "Store/priceCalculation/priceCalculationSlice";
import { getFMSProductName } from "Store/texts/helpers/FMSproductName";
import { useProductTexts } from "Store/texts/hooks";
import { reverseAndPadDDMMYYYY } from "Utils/dateUtils";
import { useDispatch } from "react-redux";
import { Route } from "react-router";
import { BackendProductInfo } from "../../productConstants";
import { ProductBackendName } from "../../productTypes";
import { ChildProductDetails } from "./ProductDetails/ChildProductDetails";
import { ChildProductIntro } from "./ProductIntro/ChildProductIntro";
import { ChildProductPrice } from "./ProductPrice/ChildProductPrice";

interface Props {
  numberOfProductsInCart: number;
}

export const ChildCheckPrice = ({
  numberOfProductsInCart,
}: Props): React.ReactElement => {
  const dispatch = useDispatch();
  const { getText } = useTexts();
  const [productTexts, lang] = useProductTexts(
    getFMSProductName(INSURANCE_NAME_VALUE.CHILD),
  );
  useExistingProductState(INSURANCE_NAME_VALUE.CHILD);

  useEffect(() => {
    dispatch(setCheckPriceProducts([INSURANCE_NAME_VALUE.CHILD]));
  }, []);

  const updatePriceCalculations = (
    formValues: ChildProductDetailsFormValues,
  ): void => {
    dispatch(
      updatePriceCalculationFormState({
        stepId: CHILD_ABOUT_STEP.id,
        formState: {
          ...formValues,
          childBirthDate: formValues.childBirthDate,
        },
      }),
    );

    const childPayload = {
      productPriceUrl: BackendProductInfo.CHILD.priceReqUrl,
      stepForwardOnSuccess: true,
      numberOfProductsInCart,
      requestInfo: {
        childDateOfBirth: formValues.childBirthDate
          ? reverseAndPadDDMMYYYY(formValues.childBirthDate)
          : undefined,
      },
    };

    const childHealthPayload = {
      productPriceUrl: BackendProductInfo.CHILD_HEALTH.priceReqUrl,
      stepForwardOnSuccess: false,
      numberOfProductsInCart: numberOfProductsInCart + 1,
      requestInfo: {
        childDateOfBirth: formValues.childBirthDate
          ? reverseAndPadDDMMYYYY(formValues.childBirthDate)
          : undefined,
      },
    };

    dispatch(
      sendPriceCalculationRequestsStart([childPayload, childHealthPayload]),
    );
  };

  return (
    <ProductTile
      title={productTexts.name[lang]}
      productName={getText("insuranceproduct.child.name")}
      productBackendName={ProductBackendName.CHILD}
      productPath={PRODUCT_PATH}
      productSteps={CHILD_STEPS}
      iconName={Icons.CHILD}
    >
      <Route
        exact
        path={`${PRODUCT_PATH}/${CHILD_ABOUT_YOU_STEP.id}`}
        render={() => (
          <ActiveStep>
            <ChildProductIntro />
          </ActiveStep>
        )}
      />
      <Route
        exact
        path={`${PRODUCT_PATH}/${CHILD_ABOUT_STEP.id}`}
        render={() => (
          <ActiveStep>
            <ChildProductDetails updatePriceRequest={updatePriceCalculations} />
          </ActiveStep>
        )}
      />
      <Route
        exact
        path={`${PRODUCT_PATH}/${CHILD_PRICE_STEP.id}`}
        render={() => (
          <ActiveStep>
            <ChildProductPrice />
          </ActiveStep>
        )}
      />
    </ProductTile>
  );
};
